// Mesmas regras do PasswordPolicy do backend (anubis-API). Se mudar lá, mude aqui.
export const PASSWORD_RULES =
  'A senha deve ter no mínimo 10 caracteres e no máximo 72 (letra acentuada conta como 2), com letra maiúscula, letra minúscula, número e caractere especial, e não pode conter o nome de usuário.';

const MIN_LENGTH = 10;
// O BCrypt do backend só aceita até 72 bytes
const MAX_BYTES = 72;

const utf8Bytes = (text: string): number => {
  let bytes = 0;
  for (const ch of text) {
    const cp = ch.codePointAt(0) ?? 0;
    bytes += cp < 0x80 ? 1 : cp < 0x800 ? 2 : cp < 0x10000 ? 3 : 4;
  }
  return bytes;
};

export const isStrongPassword = (password: string, username: string): boolean => {
  if (!password || password.length < MIN_LENGTH) return false;
  if (utf8Bytes(password) > MAX_BYTES) return false;
  if (!/\p{Lu}/u.test(password)) return false;
  if (!/\p{Ll}/u.test(password)) return false;
  if (!/\p{Nd}/u.test(password)) return false;
  if (!/[^\p{L}\p{N}\s]/u.test(password)) return false;

  const user = (username || '').trim().toLowerCase();
  return user.length < 3 || !password.toLowerCase().includes(user);
};
